import { format } from 'date-fns';
export function getBadgeFileName(accountDisplayName) {
    const displayName = accountDisplayName.replace(' ', '_');
    const dateAndTime = format(new Date(), 'MMddyyyy_HHmmss');
    return `badge_${displayName}_${dateAndTime}.pdf`;
}
